import request from '@/utils/request'
export function wxGetToken (code) {
  const data = {
    'code': code
  }
  return request({
    url: '/callBack',
    method: 'post',
    data
  })
}

export function isUserInfo (userId) {
  const data = {
    userId: userId
  }
  return request({
    url: '/isUserInfo',
    method: 'post',
    data
  })
}

export function setBaseInfo (object) {
  const data = object
  return request({
    url: '/editUser',
    method: 'post',
    data
  })
}

export function getUserInfo (userId) {
  const data = {
    userId: userId
  }
  return request({
    url: '/getUserInfo',
    method: 'post',
    data
  })
}

export function getVerificationCode (phone) {
  const data = {
    phone: phone
  }
  return request({
    url: '/getVerificationCode',
    method: 'post',
    data
  })
}

export function isValidCode (phone, verificationCode) {
  const data = {
    phone: phone,
    verificationCode: verificationCode
  }
  return request({
    url: '/isValidCode',
    method: 'post',
    data
  })
}
export function getTxtCommit () {
  return request({
    url: '/getTips',
    method: 'get'
  })
}
// 模板推送
export function sendTemplate (params) {
  const data = params
  return request({
    url: 'https://api.weixin.qq.com/cgi-bin/message/template/send?access_token=ACCESS_TOKEN',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js